import axios from 'axios';
import { supabase } from '../config/supabase.config';
import { API_URL } from '../config/supabase.config';
import { SearchResult, SearchParams } from '../types/search.types';

const getAuthHeader = async () => {
  const { data: { session } } = await supabase.auth.getSession();
  return {
    headers: {
      Authorization: `Bearer ${session?.access_token}`,
      'Content-Type': 'application/json',
    },
  };
};

export const searchService = {
  async semanticSearch(params: SearchParams): Promise<SearchResult[]> {
    const config = await getAuthHeader();
    const response = await axios.post(
      `${API_URL}/rag/search`,
      {
        query: params.query,
        limit: params.limit || 10,
        threshold: params.threshold || 0.3,  // Changed from 0.7 to match backend
      },
      config
    );
    return response.data.results || [];
  },

  async askQuestion(question: string): Promise<{ answer: string; sources: any[] }> {
    const config = await getAuthHeader();
    const response = await axios.post(
      `${API_URL}/rag/query`,
      { question },
      config
    );
    return response.data;
  },
};